import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="app-footer">
      <a href="https://www.calmu.design" target="_blank" rel="noopener noreferrer">calmu.design</a>
      <span className="app-footer-separator">|</span>
      <a href="https://www.calmu.design/gallery/tou" target="_blank" rel="noopener noreferrer">利用規約</a>
    </footer>
  );
}

export default Footer;
